import { ReactNode } from 'react';
import '../components/tailwind.css';
import '../components/tailwind-shell.css';

interface TailwindLayoutProps {
  children: ReactNode;
}

export default function TailwindLayout({ children }: TailwindLayoutProps) {
  return (
    <div className="tailwind-layout-shell">
      <div id="tailwind-root">{children}</div>
    </div>
  );
}
